

















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  UserDetail,
  RoleInInstitution,
  ZuzhijiagouList,
  SearchUsers,
  AddComposeUser,
} from "@/request/manage";
import { GetCenter } from "@/request/common";
@Component({})
export default class Name extends Vue {
  private type: any = "新增";
  private data: any = {};
  private institution: any = {};
  private institutions: any[] = [];
  private user: any = {
    ars: [
      {
        institution_id: "",
        role_id: "",
        roles: [],
        parent_id: "",
      },
    ],
  };
  private account: any = {};
  private accounts: any = {};
  private ifShowAccountSearch: boolean = false;
  private searchAccountText: any = "";
  private roles: any[] = [];
  private centers: any[] = [];
  private get configuration() {
    return this.$store.state.configuration;
  }
  private isRepeat(arr: any) {
    let resultArr: any = [];
    arr.forEach((ele: any) => {
      if (ele) {
        resultArr.push(ele);
      }
    });
    const hash = {};
    for (const i in resultArr) {
      if (Object.prototype.hasOwnProperty.call(resultArr, i)) {
        if ((hash as any)[resultArr[i]]) {
          return true;
        }
        (hash as any)[resultArr[i]] = true;
      }
    }
    return false;
  }
  private open(e: any, i: any) {
    if (!e) {
      let arr: any = [];
      this.user.ars.forEach((ele: any) => {
        arr.push(ele.parent_id);
      });
      if (this.isRepeat(arr)) {
        this.$message.error("当前专病库已经创建角色，不能重复创建！");
        this.user.ars[i]["institution_id"] = "";
        // this.$set(this.user.ars[i], "institution_id", "");
        this.$forceUpdate();
        this.$set(this.user.ars[i], "institution_id", "");
      }
    }
  }
  private change(e: any, i: any) {
    const d: any = (this.$refs as any)[
      "myCascader" + i
    ][0].getCheckedNodes()[0];
    if (d.level == "1") {
      this.$set(this.user.ars[i], "parent_id", d.value);
    } else {
      if (d.parent.level == "1") {
        this.$set(this.user.ars[i], "parent_id", d.parent.value);
      } else {
        if (d.parent.parent.level == "1") {
          this.$set(this.user.ars[i], "parent_id", d.parent.parent.value);
        }
      }
    }
    this.getRoleInInstitution(e, i);
  }
  /**
   * @description 添加角色
   */
  private addOne() {
    if (this.user.ars.length < this.centers.length) {
      const obj = {
        institution_id: "",
        role_id: "",
        roles: [],
        parent_id: "",
      };
      this.user.ars.push(obj);
      this.$forceUpdate();
    }
  }
  /**
   * @description 删除角色
   */
  private delOne(i: any) {
    this.user.ars.splice(i, 1);
    this.$forceUpdate();
  }
  /**
   * @description 获得专病数据库列表
   */
  private getCenterList() {
    GetCenter(this).then((data: any) => {
      this.centers = data;
    });
  }
  /**
   * @description 获取用户详情
   */
  private getUserDetail() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          user_id: this.user.user_id,
        },
      };
      UserDetail(this, params)
        .then((data: any) => {
          this.user = data;
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获得可选的组织结构列表
   */
  private getZuzhijiagouList(text: any) {
    const params: any = {
      params: {
        search: text,
        kind: true,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      this.institutions = data;
    });
  }
  /**
   * @description 获得机构和角色的关系
   */
  private getRoleInInstitution(id: any, i: any) {
    return new Promise((resolve, reject) => {
      if (!id) {
        resolve(false);
        return;
      }
      const params: any = {
        params: {
          institution_id: id,
        },
      };
      RoleInInstitution(this, params)
        .then((data: any) => {
          this.$set(this.user.ars[i], "roles", data);
          this.$forceUpdate();
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 角色改变
   */
  private roleChange() {
    // 清空可选账户的值
    this.user["关联账号"] = [];
    this.$forceUpdate();
  }
  /**
   * @description 打开搜索账号弹窗
   */
  private openSearchAccount() {
    this.ifShowAccountSearch = true;
    this.$nextTick().then(() => {
      (this.$refs["searchAccountSelect"] as any).focus();
      this.$nextTick().then(() => {
        this.searchAccountText = this.user["用户名"];
      });
    });
  }
  /**
   * @description 获得账号
   */
  private getAccount(text: any) {
    const params: any = {
      params: {
        search: text,
      },
    };
    SearchUsers(this, params).then((data: any) => {
      this.accounts = data;
    });
  }
  /**
   * @description 选择一个已有账号
   */
  private selectAccount(e: any) {
    this.user = e;
    this.ifShowAccountSearch = false;
  }
  /**
   * @description 保存
   */
  private save() {
    let institutionIds: any = [];
    let roleIds: any = [];
    this.user.ars.forEach((ele: any) => {
      institutionIds.push(ele.institution_id);
      roleIds.push(ele.role_id);
    });
    for (const i of institutionIds) {
      if (!i) {
        this.$message.warning("所属层级必须选择");
        return;
      }
    }
    for (const i of roleIds) {
      if (!i) {
        this.$message.warning("角色必须选择");
        return;
      }
    }

    if (this.user["姓名"] === "admin") {
      this.$message.warning("对不起，不能编辑超级管理员账号");
      return;
    }
    if (this.user["用户名"].length > 18) {
      this.$message.warning("账户名太长，请输入18个字符以内的账户名");
      return;
    }
    if (!this.user["用户名"]) {
      this.$message.warning("请填写账户名");
      return;
    }
    if (!this.user["姓名"]) {
      this.$message.warning("请填写姓名");
      return;
    }
    // if (!this.user["性别"]) {
    //   this.$message.warning("请选择性别");
    //   return;
    // }
    // if (!this.user["手机号"]) {
    //   this.$message.warning("请填写手机号");
    //   return;
    // }
    if (this.user["手机号"] && this.user["手机号"].length !== 11) {
      this.$message.warning("手机号长度不正确");
      return;
    }
    if (
      this.user["手机号"] &&
      !/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.user["手机号"])
    ) {
      this.$message.warning("手机号格式不正确");
      return;
    }
    if (!this.user["状态"]) {
      this.$message.warning("状态必须选择");
      return;
    }
    const params = JSON.parse(JSON.stringify(this.user));
    params.institution_id = institutionIds;
    params.role_id = roleIds;
    delete params.ars;
    AddComposeUser(this, params).then((data: any) => {
      this.$message.success(this.type + "成功");
      this.$router.back();
    });
  }
  private changeData() {
    if (!this.data || !this.data.user_id) {
      return;
    }
    this.user.user_id = this.data.user_id;
    this.getUserDetail().then(() => {
      this.user.ars = [];
      this.data["角色"].forEach((ele: any, i: any) => {
        const obj = {
          institution_id: "",
          role_id: "",
          roles: [],
          parent_id: "",
          disabled: true,
        };
        this.user.ars.push(obj);
        this.getRoleInInstitution(
          ele["组织机构"][ele["组织机构"].length - 1].institution_id,
          i
        ).then(() => {
          this.$set(
            this.user.ars[i],
            "institution_id",
            ele["组织机构"][ele["组织机构"].length - 1].institution_id
          );
          this.$set(
            this.user.ars[i],
            "parent_id",
            ele["组织机构"][0].institution_id
          );
          this.$set(this.user.ars[i], "role_id", ele.role.role_id);
          this.$forceUpdate();
        });
      });
    });
  }
  private mounted() {
    const data = this.$store.state.zhanghu;
    if (data && data.user_id) {
      this.data = JSON.parse(JSON.stringify(data));
      this.type = "编辑";
      this.changeData();
    }
    this.getZuzhijiagouList(" ");
    this.getCenterList();
  }
}
